import React from "react";
import { Form, Row, Col, Divider, Checkbox, Typography, Select, Input } from "antd";
import { c_RegimenFiscal } from "../../../SATCatalogos/index";
import SelectRazonSocial from "../../Inputs/SelectRazonSocial";

const { Title } = Typography;
const { Option } = Select;

const EmisorSection = () => {

    const form = Form.useFormInstance();

    const handleRazonSocialSelect = (data) => {
        if (form) {
            form.setFieldsValue({
                Emisor: {
                    Nombre: data.razon_social,
                    Rfc: data.rfc,
                    RegimenFiscal: data.regimen_fiscal,
                },
            });
        }
    };

    return (
        <>
            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
                <Title level={5} className="mb-1">
                    Información del Emisor
                </Title>
            </Row>
            <Row className="mb-1">
                <Col span={24}>
                    <Form.Item noStyle name="enviar_responsable" valuePropName="checked">
                        <Checkbox>Enviar al Responsable una copia de la factura</Checkbox>
                    </Form.Item>
                </Col>
            </Row>
            <Row justify="center" gutter={[16, 16]}>
                <Col xs={20} md={12}>
                    <Form.Item
                        name="razon_social_id"
                        label="Razón Social"
                        rules={[
                            {
                                required: true,
                                message: "Ingrese la Razón Social desde donde se efectuará la factura",
                            },
                        ]}
                    >
                        <SelectRazonSocial onSelect={handleRazonSocialSelect} />
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name={["Emisor", "Nombre"]}
                        label="Nombre del Emisor"
                        rules={[
                            {
                                required: true,
                                message: "Ingrese el nombre del Emisor (como se registró en el SAT)",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name={["Emisor", "Rfc"]}
                        label="Registro Federal de Contribuyentes (RFC)"
                        rules={[{ required: true, message: "Ingrese el RFC del Emisor" }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name={["Emisor", "RegimenFiscal"]}
                        label="Régimen Fiscal"
                        rules={[{ required: true, message: "Ingrese el Régimen Fiscal" }]}
                    >
                        <Select showSearch optionFilterProp="filter">
                            {c_RegimenFiscal.map(({ regimen_fiscal, descripción }) => (
                                <Option
                                    key={regimen_fiscal}
                                    filter={`${regimen_fiscal} ${descripción}`}
                                    value={regimen_fiscal}
                                >
                                    <strong>{regimen_fiscal}</strong> - {descripción}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col xs={20} md={12}>
                    <Form.Item
                        name={["Emisor", "DomicilioFiscalEmisor"]}
                        label="Domicilio Fiscal Emisor (Código Postal)"
                        rules={[{ required: true, message: "Ingrese el domicilio del emisor." }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default EmisorSection;
